import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#58666F",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M12 1a11 11 0 0 1 10.163 6.79A11.002 11.002 0 0 1 4.222 19.778 11.002 11.002 0 0 1 7.79 1.837 11 11 0 0 1 12 1Z"
    }, null, -1)
  ])))
}
export default { render: render }